<div style="display:flex; align-items: center; flex-direction: column; margin-bottom: 30px;">
  <div class="headlines">Classification</div>
  <div style="width: 60%; margin:auto">
    Search for a drug to get all available information on DrugOn.

    <div style="margin-top: 20px; font-weight: bold;">
      Card Explanation:
      <ul style="font-weight: normal;">
        <li>Selected drug class: Gives you a recommendation for the drug class of the selected drug.</li>
        <li>Targets: Indicates the genes that may be targeted by the selected drug.</li>
        <li>Synonym: Shows alternative names of the selected drug.</li>
        <li>  Identifier: Displays the identifiers of the selected drug that are used by other databases.</li>
        <li>ATC Codes: Finds the drug classes based on ATC nomenclature.</li>
        <li>MesH terms: Provides you with the drug classes based on MesH terms.</li>
        <li>Kegg: Provides you with the drug classes based on KEGG.</li>
        <li>ClueIO: Provides you with the drug classes based on ClueIO. </li>
      </ul>
    </div>
  </div>
</div>

<form [formGroup]="drugForm" (ngSubmit)="getDrugInfo()">
  <input type="text" id="drugName" formControlName="drugName" placeholder="Search for a drug, e.g. Olaparib"
    aria-label="Number" matInput [matAutocomplete]="auto" class="form-input">
  <mat-autocomplete #auto="matAutocomplete">
    <cdk-virtual-scroll-viewport [ngStyle]="{height: '200px'}" itemSize="10">
      <mat-option *ngFor="let drug of filteredDrugs | async" [value]="drug">
        {{drug}}
      </mat-option>
    </cdk-virtual-scroll-viewport>
  </mat-autocomplete>
  <button type="submit" class="form-button" [disabled]="!drugForm.valid">Submit</button>
</form>

<div *ngIf="drug.name">
  <div class="drug-header">
    <img class="slidein" src="./assets/images/MdiPill.svg" alt="">
    <div class="headlines">{{drug.name}}</div>
  </div>

  <!-- Drug Class -->
  <div class="grid-3-columns">
    <div class="card" *ngIf="drug.class">
      <div class="card-header">
        <h2>Selected Drug Class</h2>
      </div>
      <ul>
        <li *ngFor="let class of drug.class">{{class}}</li>
      </ul>
    </div>

    <!-- Target Pharmacological -->
    <div class="card" *ngIf="drug.targets">
      <div>
        <h2>Targets (pharmacological)</h2>
      </div>
      <ul>
        <li *ngFor="let target of drug.targets.pharmacological">{{target}}</li>
      </ul>
    </div>

    <!-- Target Non-Pharmacological -->
    <div class="card" *ngIf="drug.targets">
      <div>
        <h2>Targets (non-pharmacological)</h2>
      </div>
      <ul>
        <li *ngFor="let target of drug.targets.non_pharmacological">{{target}}</li>
      </ul>
    </div>

    <!-- Synonym -->
    <div class="card">
      <div>
        <h2>Synonyms</h2>
      </div>
      <ul>
        <li *ngFor="let synonym of drug.synonyms">{{synonym}}</li>
      </ul>
    </div>

    <!-- Identifier -->
    <div class="card" *ngIf="drug.identifiers">
      <div>
        <h2>Identifiers</h2>
      </div>
      <ul>
        <li *ngFor="let identifier of drug.identifiers">{{identifier}}</li>
      </ul>
    </div>

    <!-- ATC -->
    <div class="card" *ngIf="drug.sources">
      <div>
        <h2>ATC-Codes</h2>
      </div>
      <ul>
        <li *ngFor="let class of drug.sources.atc">{{class}}</li>
      </ul>
    </div>

    <!-- MesH -->
    <div class="card" *ngIf="drug.sources">
      <div>
        <h2>MesH-Terms</h2>
      </div>
      <ul>
        <li *ngFor="let class of drug.sources.mesh">{{class}}</li>
      </ul>
    </div>

    <!-- KEGG Class -->
    <div class="card" *ngIf="drug.sources.kegg_class">
      <div>
        <h2>KEGG Classes</h2>
      </div>
      <ul>
        <li *ngFor="let class of drug.sources.kegg_class">{{class}}</li>
      </ul>
    </div>

    <!-- KEGG Group -->
    <div class="card" *ngIf="drug.sources.kegg_group">
      <div>
        <h2>KEGG Groups</h2>
      </div>
      <ul>
        <li *ngFor="let class of drug.sources.kegg_group">{{class}}</li>
      </ul>
    </div>

    <!-- ClueIO -->
    <div class="card" *ngIf="drug.sources">
      <div>
        <h2>Clue IO</h2>
      </div>
      <ul>
        <li *ngFor="let class of drug.sources.clue_io">{{class}}</li>
      </ul>
    </div>
  </div>
</div>